import './Footer.css'

const Footer = () => (
  <footer className='footer'>
    <a
      href='https://github.com/cwonjin11'
      className='link footer__link'
    >
      2021 © Copyright Wonjin Cho. All Rights Reserved
    </a>
  </footer>
)

export default Footer
